<app-modal-card [visible]="visible" [closable]="false">
  <div class="flex flex-col items-center justify-center w-full h-full mb-6">
    <h3 class="px-2 mb-6 sm:px-6" translate="kyc.loading"></h3>
    <app-loader></app-loader>
  </div>
</app-modal-card>
